<template>
  <router-view/>

</template>

<style>
html,body,#app {
  height: 100%;
 
}
.el-dialog {
  min-width: auto !important;
}
</style>